import { Route, Redirect } from "react-router-dom";
import { IonApp} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import FirebaseProvider from "./components/firebase-provider";
import PrivatePage from "./components/private-page";
import LoginPage from "./pages/login-page";
import PrivateRoute from "./components/private-route";

const App: React.FC = () => (
  <FirebaseProvider>
    <IonApp>
      <IonReactRouter>
          <Redirect path="/" to="/app/dashboard" />
          <PrivateRoute path="/app" component={PrivatePage} />
          <Route path="/login" component={LoginPage} />
      </IonReactRouter>
    </IonApp>
  </FirebaseProvider>
);

export default App;
